import React from 'react';
import Accessories from './Accessories';
import Phone from './Phone';
import Protection from './Protection';
import Special from './Special';
import Service from './Service';

import './stage.scss';
import './style.scss';
import './service.scss';

export function SaleAd({ mobile = false }) {
  return (
    <>
      <Accessories mobile={mobile} />
      <Phone mobile={mobile} />
      <Protection mobile={mobile} />
      <Special mobile={mobile} />
      <Service mobile={mobile} />
    </>
  );
}
